import { render, staticRenderFns } from "./PeopleConfig.vue?vue&type=template&id=6670f231&scoped=true&"
import script from "./PeopleConfig.vue?vue&type=script&lang=js&"
export * from "./PeopleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670f231",
  null
  
)

export default component.exports